import { clickButtonAction, clickButtonUrl, postMessageToBot, clickVote } from "#scripts/dialog/dialog_messages.js";
import { restartConversation, downloadConversation, deleteConversation, setChatFocus, toggleChatVisibility } from "#scripts/dialog/dialog_general.js";
import { isMobile } from "#scripts/general_functions.js";
import { search } from "#scripts/dialog/dialog_search.js";
import { getAimData } from "#scripts/dialog/dialog_aim.js";

export const bindDialogEvents = () => {
	// Keyup for input field
	document.body.addEventListener("keyup", function (event) {
		if (event.target && event.target.id === "feedbackInput") {
			const charCounter = document.getElementById("chatinput__charCounter");
			const chatInput = document.getElementById("feedbackInput");
			if (charCounter && chatInput) {
				charCounter.innerText = `${chatInput.value.length}/${chatInput.maxLength}`;
			}
			const key = event.keyCode || event.which;
			if (key === 13 && chatInput.value.length > 0) {
				if (charCounter) charCounter.innerText = "";
				postMessageToBot(chatInput.value);
				expandChatDialog();
				chatInput.value = "";
			}
		}
	});

	// Scroll event for mobile
	if (window.visualViewport) {
		window.visualViewport.addEventListener("scroll", () => {
			if (isMobile()) {
				const chatContainer = document.querySelector(".chatbot__container");
				if (chatContainer && chatContainer.classList.contains("chatbot__mobile-show")) {
					chatContainer.style.height = `${window.innerHeight}px`;
				}
			}
		});
	}

	// Click events
	document.body.addEventListener("click", function (event) {
		const target = event.target;

		// Modal close
		if (target.closest("#chatbot__modal__close")) {
			toggleChatVisibility(true);
			document.querySelectorAll(".chatbot__mobile-show").forEach(el => el.classList.remove("chatbot__mobile-show"));
			document.querySelector("main")?.classList.remove("d-none");
			document.querySelector("footer")?.classList.remove("d-none");
			document.querySelector(".navbar")?.classList.remove("d-none");
			document.querySelector(".warnings")?.classList.remove("d-none");
			document.querySelector(".chatbot__container").style.height = "unset";
			document.body.classList.remove("overflow-hidden");
		}

		// Modal option/info page toggle
		if (
			target.closest("#chatbot__modal__option") ||
			target.closest("#chatbot__infopage__close") ||
			target.closest(".dialog__infopage__container .dialog__actions__ddlink")
		) {
			document.querySelectorAll(".chatbot__modal__option").forEach(el => el.classList.toggle("chatbot__modal__option-active"));
			document.querySelectorAll(".chatbot__infopage").forEach(el => el.classList.toggle("d-none"));
		}

		// Button dialog__fromkari__link
		if (target.closest("button.dialog__fromkari__link")) {
			// if (!isMobile()) {
				const btn = target.closest("button.dialog__fromkari__link");
				clickButtonAction(btn.dataset.id);
			// }
		}

		// Anchor dialog__fromkari__link
		if (target.closest("a.dialog__fromkari__link")) {
			if (!isMobile()) {
				const a = target.closest("a.dialog__fromkari__link");
				event.preventDefault();
				clickButtonUrl(a, event);
				// window.location.assign(a.href);
			}
		}

		// Feedback button
		if (target.closest("button.dialog__feedback__button")) {
			const btn = target.closest("button.dialog__feedback__button");
			const val = btn.dataset.value;
			let remove = "";
			if (btn.classList.contains("active")) {
				remove = "remove-";
			}
			btn.parentElement.querySelectorAll(".btn").forEach(el => el.classList.remove("active"));
			btn.classList.add("active");
			clickVote(btn.dataset.id, remove + val);
		}

		// Download dialog
		if (target.closest(".download")) {
			downloadConversation().then(blob => {
				const url = URL.createObjectURL(blob);
				const a = document.createElement('a'); a.href = url; a.download = 'samtale.txt'; a.click(); URL.revokeObjectURL(url);
			});
		}

		// Delete dialog
		if (target.closest(".deletedialog")) {
			deleteConversation();
		}

		// Restart chat
		if (target.closest(".restart-chat")) {
			restartConversation();
		}

		// Hide chat
		if (target.closest(".hidechat")) {
			setChatFocus(true, false);
			toggleChatVisibility(true);
		}

		// Ask button
		if (target.closest(".dialog__askbutton")) {
			const chatContainer = document.querySelector(".chatbot__container");
			const chatMessageArea = document.getElementById("chatbot__messagearea");
			if (chatContainer) chatContainer.classList.add("chatbot__mobile-show");
			toggleChatVisibility(false);
			if (chatContainer?.classList.contains("chatbot__mobile-show") && chatMessageArea) {
				chatMessageArea.scrollTo(0, chatMessageArea.scrollHeight);
				chatContainer.style.height = `${window.visualViewport.height}px`;
			}
		}

		// dialog__fromkari__mal_blokk
		if (target.closest("a.dialog__fromkari__mal_blokk")) {
			event.preventDefault();
			event.stopPropagation();
			const a = target.closest("a.dialog__fromkari__mal_blokk");
			const id = a.dataset.id;
			if (a.dataset.search) {
				search(a.dataset.search);
				return;
			}
			getAimData(id);
		}

		// Send button
		if (target.closest(".dialog__sendbutton")) {
			expandChatDialog();
			const inputField = document.getElementById("feedbackInput");
			if (inputField && inputField.value !== "") {
				postMessageToBot(inputField.value);
				inputField.value = "";
			}
			if (!isMobile() && inputField) {
				inputField.focus();
			}
		}

		// Actions toggle
		if (target.closest(".dialog__actions__toggle")) {
			event.preventDefault();
			const toggle = target.closest(".dialog__actions__toggle");
			toggle.classList.toggle("dialog__actions__link-active");
			document.querySelectorAll(".dialog__chevron__toggle").forEach(el => {
				el.classList.toggle("material-chevron-bottom");
				el.classList.toggle("material-chevron-top");
			});
			document.querySelectorAll(".dialog__actions").forEach(el => el.classList.toggle("dialog__actions__show"));
		}

		// Actions ddlink
		if (target.closest(".dialog__actions__ddlink")) {
			document.querySelectorAll(".dialog__chevron__toggle").forEach(el => {
				el.classList.toggle("material-chevron-bottom");
				el.classList.toggle("material-chevron-top");
			});
			document.querySelectorAll(".dialog__actions").forEach(el => el.classList.toggle("dialog__actions__show"));
			document.querySelectorAll(".dialog__actions__toggle").forEach(el => el.classList.toggle("dialog__actions__link-active"));
		}
	}, { capture: true });

	// Touch events for mobile
	document.body.addEventListener("touchstart", function (event) {
		const target = event.target;

		// Button dialog__fromkari__link
		if (target.closest("button.dialog__fromkari__link")) {
			const btn = target.closest("button.dialog__fromkari__link");
			clickButtonAction(btn.dataset.id);
		}

		// Anchor dialog__fromkari__link
		if (target.closest("a.dialog__fromkari__link")) {
			const a = target.closest("a.dialog__fromkari__link");
			event.preventDefault();
			clickButtonUrl(a, event);
			// window.location.assign(a.href);
		}
	});

	// Focus event for input
	document.body.addEventListener("focus", function (event) {
		if (event.target && event.target.id === "feedbackInput") {
			toggleChatVisibility(false)
			// Mobile-specific focus logic can be added here if needed
		}


	}, true);

	// Window resize
	window.onresize = () => {
		const chatContainer = document.querySelector(".chatbot__container");
		if (isMobile()) {
			chatContainer?.classList.add("chatbot__mobile");
		} else {
			chatContainer?.classList.remove("chatbot__mobile");
		}
	};
};

const expandChatDialog = () => {
	if (isMobile()) {
		const chatContainer = document.querySelector(".chatbot__container");
		const chatMessageArea = document.getElementById("chatbot__messagearea");
		if (chatContainer) chatContainer.classList.add("chatbot__mobile-show");
		toggleChatVisibility(false);
		if (chatContainer && chatContainer.classList.contains("chatbot__mobile-show") && chatMessageArea) {
			chatMessageArea.scrollTo(0, chatMessageArea.scrollHeight);
			chatContainer.style.height = `${window.visualViewport.height}px`;
		}
	} else {
		if (!document.querySelector(".dialog__fromuser")) {
			document.querySelector(".chatbot-search--container")?.classList.add("transform-bg");
		}
		toggleChatVisibility(false);
	}
};
